import MessagePanelImages from "./message-panel-images";

export default MessagePanelImages;
